import {
  CandidateActionDialogs,
  useCandidateActions,
} from "./CandidateActionController"
import {
  LeadOutreachDialogs,
  useLeadOutreachActions,
} from "./LeadOutreachDialogs"
import { leadPhoneValue } from "./NameWithContactActionsCell"

/**
 * Contact actions for MLS / uploaded leads.
 * Uses in-app Twilio / SMS / email when the lead is already in Candidates,
 * otherwise reaches out directly without importing the lead.
 */
export function useLeadContactActions(
  openSnackbar,
  { leadSource = "mls", onOutreachComplete } = {}
) {
  const candidateActions = useCandidateActions(openSnackbar)
  const leadActions = useLeadOutreachActions(
    openSnackbar,
    leadSource,
    onOutreachComplete
  )

  function toActionCandidate(lead) {
    const phone = leadPhoneValue(lead)
    const email = lead?.email?.trim() || ""
    if (!lead?.candidate_id) {
      return null
    }
    return {
      id: lead.candidate_id,
      phone,
      email,
      candidate_name: lead.name,
      company_name: lead.office_name || "",
    }
  }

  function routeLeadAction(e, lead, { requirePhone, requireEmail }, handlers) {
    e.preventDefault?.()
    e.stopPropagation()

    if (requirePhone && !leadPhoneValue(lead)) {
      openSnackbar?.("No phone number available for this lead")
      return
    }
    if (requireEmail && !lead?.email?.trim()) {
      openSnackbar?.("No email available for this lead")
      return
    }

    const existingCandidate = toActionCandidate(lead)
    if (existingCandidate) {
      handlers.candidate(e, existingCandidate)
      return
    }
    handlers.lead(e, lead)
  }

  function handleCallButtonClicked(e, lead) {
    routeLeadAction(
      e,
      lead,
      { requirePhone: true },
      {
        candidate: candidateActions.handleCallButtonClicked,
        lead: leadActions.handleCallButtonClicked,
      }
    )
  }

  function handleSMSButtonClicked(e, lead) {
    routeLeadAction(
      e,
      lead,
      { requirePhone: true },
      {
        candidate: candidateActions.handleSMSButtonClicked,
        lead: leadActions.handleSMSButtonClicked,
      }
    )
  }

  function handleEmailButtonClicked(e, lead) {
    routeLeadAction(
      e,
      lead,
      { requireEmail: true },
      {
        candidate: candidateActions.handleEmailButtonClicked,
        lead: leadActions.handleEmailButtonClicked,
      }
    )
  }

  return {
    ...candidateActions,
    ...leadActions,
    handleCallButtonClicked,
    handleSMSButtonClicked,
    handleEmailButtonClicked,
  }
}

export function LeadContactActionDialogs({ actionsState }) {
  return (
    <>
      <CandidateActionDialogs actionsState={actionsState} />
      <LeadOutreachDialogs actionsState={actionsState} />
    </>
  )
}

export { CandidateActionDialogs }
